// https://stackoverflow.com/a/64123628

export const keepIfInEnum = <T>(value: string | undefined, enumObject: { [key: string]: T }) => {
    if (value === undefined) return;
    if (Object.values(enumObject).includes(value as unknown as T)) {
        return value as unknown as T;
    } else {
        return undefined;
    }
};
